export default "__VITE_ASSET__BWZJd6Rv__"